<template>
	<v-container fluid>
		<v-row>
			<v-col
					v-for="book in searchResults"
					:key="book.code"
					cols="10"
					md="6"
					lg="4">
				<v-card class="mb-3" elevation="3">
					<v-card-title class="headline primaryLighter white--text">
						<div class="book-titlebar">
							<v-chip
									class="custom-chip title-chip"
									color="secondary"
									outlined
									@click="openBookInfo(book)"
							>
								<span class="title-text">{{ book.title }}</span>
							</v-chip>

							<v-tooltip right>
								<template v-slot:activator="{ on }">
									<v-icon
											class="title-icon"
											v-on="on"
											:color="checkBookSelectable(book)?'lightSeaGreen' : 'indianRed'"
									>
										{{ checkBookSelectable(book)?'mdi-playlist-check': 'mdi-alert-outline' }}
									</v-icon>
								</template>
								<span>
        {{ checkBookSelectable(book)
          ? 'Το Σύγγραμμα είναι διαθέσιμο προς επιλογή'
          : 'Το Σύγγραμμα δεν είναι διαθέσιμο προς επιλογή' }}
      </span>
							</v-tooltip>
						</div>
					</v-card-title>


					<v-row no-gutters>
						<!-- Image Column -->
						<v-col cols="4" class="pa-0 ma-0">
							<v-img :src="imageCache[book.id] "
								   alt="blank.png"
								   contain @error="fallbackImage"
								   max-width="170px"
								   max-height="140px"
							></v-img>
						</v-col>

						<!-- Text Column -->
						<v-col cols="8" class="py-2 pr-2">


							<v-card-text class="pt-1 pb-2 px-2 text-body-2">
								<v-row justify="start">
									<span class="text-truncate" style="max-width: 60ch"><strong>Κωδικός Βιβλίου στον Εύδοξο:</strong> {{ book.id }}</span>
								</v-row>

								<v-row justify="start">
									<span class="text-truncate" style="max-width: 60ch"><strong>Έκδοση:</strong> {{ book.editionNumber }}</span>
								</v-row>

								<v-row justify="start">
									<span class="text-truncate" style="max-width: 60ch"><strong>Συγγραφείς:</strong> {{ book.authors }}</span>
								</v-row>

								<v-row justify="start">
									<span class="text-truncate" style="max-width: 60ch"><strong>ISBN:</strong> {{ book.isbn }}</span>
								</v-row>

								<v-row justify="start">
									<span class="text-truncate" style="max-width: 60ch"><strong>Τύπος:</strong> {{ utils.returnBookType(book.type) }}</span>
								</v-row>

								<v-row justify="start">
									<span class="text-truncate" style="max-width: 60ch"><strong>Διαθέτης (Εκδότης):</strong> {{ book.publisherName }}</span>
								</v-row>

							</v-card-text>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>

		<BookInfoDialog :book="selectedBook" :key="keyForReRenderBookInfoDialog"/>
	</v-container>
</template>

<script>
	import BookInfoDialog from "./BookInfoDialog";
	import utils from "../utilities";
	export default {
		name: "SearchResults",
		components: {BookInfoDialog},
		props:{
			searchResults:Array,
			imageCache: Object,
		},
		data: () => ({
			afterFirstSearch: false,
			keyForReRenderBookInfoDialog: 0,
			selectedBook: {},
			defaultCover: require('../assets/blank.png'),
		}),
		computed: {
			utils() {
				return utils
			}
		},

		methods:{

			openBookInfo(book){
				this.selectedBook = book;
				this.keyForReRenderBookInfoDialog++;
				this.$store.commit('setBookInfoDialog', true);
			},

			fallbackImage(event) {
				event.target.src = this.defaultCover;
			},

			checkBookSelectable(book) {
				if(!book.finalizedByPublisher){
					return false;
				}else if (!book.selectable){
					return false;
				}else{
					return true;
				}
			},

		}
	}
</script>

<style scoped>
	.book-titlebar{
		display: flex;
		align-items: center;
		gap: 8px;
		width: 100%;
		min-width: 0;          /* key */
	}

	.title-icon{
		flex: 0 0 auto;        /* fixed */
	}

	.title-chip{
		flex: 1 1 auto;        /* this is the “11 cols” behavior */
		min-width: 0;          /* key */
		max-width: 100%;
		display: inline-flex;
	}

	/* center content inside the chip */
	.title-chip >>> .v-chip__content{
		min-width: 0;
		width: 100%;

		display: flex;
		justify-content: center;  /* horizontal center */
		align-items: center;      /* vertical center */
	}

	/* optional: if you want the ellipsis to still work nicely */
	.title-text{
		display: block;
		min-width: 0;
		max-width: 100%;          /* important */
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		text-align: center;       /* center the visible text */
	}

</style>